import { render, staticRenderFns } from "./DatadogLinks.vue?vue&type=template&id=50a77863"
import script from "./DatadogLinks.vue?vue&type=script&lang=ts"
export * from "./DatadogLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports